import RootPage from '../pages';
import RouteConfigType from '../types/RouteConfigType';
import fileAreaRoutes from './fileAreaRoutes';
import templateRoutes from '@app/routes/templateRoutes';
import fileSearchRoutes from '@app/routes/fileSearchRoutes';
import React from 'react';
import retentionRoutes from '@app/routes/retentionRoutes';
import documentMaintenanceRoutes from '@app/routes/documentMaintenanceRoutes';
import manualRoutingRoutes from '@app/routes/manualRoutingRoutes';
const Forbidden = React.lazy(() => import('@pages/Common/Forbidden'));
const LoginPage = React.lazy(() => import('@pages/Login'));
const UploadRequest = React.lazy(() => import('@pages/UploadRequest'));

const routes: RouteConfigType[] = [
  {
    path: '/',
    title: 'Login',
    component: LoginPage,
    exact: true,
    guard: [],
  },
  {
    path: '/client-file-area',
    title: 'Client File Areas',
    component: RootPage,
    exact: false,
    guard: [],
    useInBreadcrumbs: true,
    routes: fileAreaRoutes,
  },
  {
    path: '/requestFiles/:id/:securityKey/upload',
    title: 'FileArea',
    component: UploadRequest,
    exact: true,
    guard: [],
  },
  {
    path: '/template',
    title: 'Template',
    component: RootPage,
    exact: false,
    guard: [],
    useInBreadcrumbs: true,
    disableBreadcrum: true,
    routes: templateRoutes,
  },
  {
    path: '/retention',
    title: 'Retention',
    component: RootPage,
    exact: false,
    guard: [],
    useInBreadcrumbs: true,
    disableBreadcrum: true,
    routes: retentionRoutes,
  },
  {
    path: '/document-maintenance',
    title: 'Document Maintenance',
    component: RootPage,
    exact: false,
    guard: [],
    useInBreadcrumbs: true,
    disableBreadcrum: true,
    routes: documentMaintenanceRoutes,
  },
  {
    path: '/file-search',
    title: 'File Search',
    component: RootPage,
    exact: false,
    guard: [],
    useInBreadcrumbs: true,
    disableBreadcrum: false,
    routes: fileSearchRoutes,
  },
  {
    path: '/manual-routing',
    title: 'Manual Routing',
    component: RootPage,
    exact: false,
    guard: [],
    useInBreadcrumbs: true,
    disableBreadcrum: false,
    routes: manualRoutingRoutes,
  },
  {
    path: '/forbidden',
    title: '',
    component: Forbidden,
    exact: true,
    guard: [],
    useInBreadcrumbs: false,
  },
];

export default routes;
